import { useToggle } from './useToggle'

export const useMapExcelToggles = () => {
  const { SHOW_EXPORT_BUTTON } = useToggle()
  return { mapExcelToggles: SHOW_EXPORT_BUTTON }
}
